<div class="pos-panel">
    <div class="pos-new-entity-header">
        <span class="material-icons cyan">trolley</span>
        <span class="soc-panel-h">{{'STOCK_TAKE.STOCK_TAKE_INPUT' | translate}}</span>
        <span class='soc-pill-lbl soc-cyan-pill-outline' >{{'PENDING' | translate}}</span>
    </div>
    <hr class="soc-panel-line"/>
    <form #f="ngForm" [formGroup]="form" class="soc-form-wrapper-gap-24">
        <div class="pos-actions-wrapper">
            <div class="soc-wrapper-gap-24">
                <div class="soc-display-field-wrapper">
                    <label class="soc-input-lbl w-100 text-start">{{'STOCK_TAKE.ISSUED_BY' | translate}}</label>
                    <div class="soc-display-field"> <span class="soc-display-text">{{stockTake.issuedByUser?.firstName + " " + stockTake.issuedByUser?.lastName}}</span></div>
                </div>
                <div class="soc-display-field-wrapper">
                    <label class="soc-input-lbl w-100 text-start">{{'STOCK_TAKE.ASSIGNED_TO' | translate}}</label>
                    <div class="soc-display-field"> <span class="soc-display-text">{{stockTake.assignedToUser?.firstName}} {{stockTake.assignedToUser?.lastName}}</span></div>
                </div>
            </div>
            <div class="soc-wrapper-gap-24">
                <div class="soc-display-field-wrapper">
                    <label class="soc-input-lbl w-100 text-start">{{'STOCK_TAKE.ISSUE_DATE' | translate}}</label>
                    <div class="soc-display-field"> <span class="soc-display-text">{{stockTake.issuedOn | date: 'dd MMM YYYY'}}</span></div>
                </div>
            </div>
        </div>
        <p-table *ngIf="stockTake.lineItems" class="soc-borderless-table" [value]="stockTake.lineItems" [scrollable]="true" [virtualScroll]="true" scrollHeight="calc(100vh - 462px)">
            <ng-template pTemplate="header">
                <tr> 
                    <th [style.max-width]="'185px'">{{'INVENTORY_ITEM.CODE' | translate}}</th> 
                    <th [style.max-width]="'371px'">{{'INVENTORY_ITEM.ITEM_NAME' | translate}}</th> 
                    <th [style.max-width]="'278px'">{{'STOCK_TAKE.COUNTED_QUANTITY' | translate}}</th> 
                    <th></th>    
                </tr> 
            </ng-template>
            <ng-template pTemplate="body" let-stockTakeItem  let-rowIndex="rowIndex">            
                <ng-container formArrayName="items">
                    <tr [formGroupName]="rowIndex">    
                        <td [style.max-width]="'185px'" class="secondary-td">{{stockTakeItem.item.code}}</td>
                        <td [style.max-width]="'371px'">{{stockTakeItem.item.name}}</td>
                        <td [style.max-width]="'278px'">
                            <div class="soc-addon-input-group soc-error-field-wrapper" style="width: 300px">
                                <span *ngIf="getItemControls(rowIndex).controls['quantityCounted'].invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}" tooltipPosition="top" class="material-icons soc-error-icon">info</span>
                                <div class="p-inputgroup">
                                    <input [formControlName]="'quantityCounted'" class="soc-input-text" type="text"
                                        placeholder="{{'TYPE' | translate}}" pInputText  [ngClass]="{'soc-error-active': getItemControls(rowIndex).controls['quantityCounted'].invalid && f.submitted}">
                                    <span class="p-inputgroup-addon soc-input-text"  style="width: 40px !important; " [ngClass]="{'soc-error-active-addon': getItemControls(rowIndex).controls['quantityCounted'].invalid && f.submitted}">{{ stockTakeItem.item ?
                                        (stockTakeItem.item.unitType | unitShortener | lowercase) : "-"}}</span>
                                </div>
                            </div>
                        <td></td>
                    </tr> 
                </ng-container>
            </ng-template>
        </p-table>
        <hr class="soc-panel-line"/>
        <div class="d-flex align-items-center justify-content-between">
            <button class="soc-secondary-grey-btn" type="button" (click)="navigateToMain()"><span class="material-icons-round">arrow_back</span>{{'BACK' | translate}}</button>
            <div class="soc-wrapper-gap-12 justify-content-end">
                <button class="soc-secondary-cyan-btn" type="button" (click)="navigateToMain()"> {{'CANCEL' | translate}}</button>
                <button *ngIf="stockTake.statusType == InventoryActionStatus.Pending" type="submit" class="soc-basic-cyan-btn" (click)="completeStockTake()" >{{'STOCK_TAKE.COMPLETE_STOCK_TAKE' | translate}}</button>
            </div>
        </div>
    </form>
</div>
<p-confirmDialog class="soc-confirmation-dialog"></p-confirmDialog>
<p-toast position="top-center"></p-toast>
